export default "__VITE_ASSET__774a267e__"